/* Extended DVR ("catch up") seek gate — the SINGLE source of truth for who may
   seek beyond the loaded manifest window.

   Why it exists: extended seek reaches content older than the manifest window by
   reloading a time-shifted manifest (`start=` + `ads.startOver`, see
   ShakaPlayer.seekToEpoch / the lego's applySeekTarget). That is NOT a
   low-latency-only capability — normal DASH MPDs honour `start=` too — so the
   gate must be the rollout flag + channel rollout list, never the source type
   (the old `isLowLatency` gate broke catch-up on regular channels) and never a
   second, hand-rolled copy (the classic player's PlayerUI and the lego shell had
   drifted apart).

   Rollout: `VITE_USE_LL_EXTENDED_SEEK` turns the feature on for the deployment,
   `VITE_LL_EXTENDED_SEEK_CHANNELS` lists the channels it is verified on, and the
   special entry `allChannels` (valuesAllChannelsCatchup) enables every channel.

   Consumers: `components/Player/PlayerUI/PlayerUI.jsx` (progress bar scrub, key
   moments, back-to-start) and `routes/Private/LegoPlayer/LegoPlayer.jsx` (the
   resolved boolean is injected into the Solid player as `extendedSeekEnabled`). */

import { LL_EXTENDED_SEEK_CHANNELS, USE_LL_EXTENDED_SEEK } from './env';
import { valuesAllChannelsCatchup } from './constants';

/**
 * Whether this channel may seek beyond the loaded manifest window.
 *
 * @param {string} channelId - raw channel id (no provider suffix).
 * @returns {boolean} true when the feature flag is on AND the channel is in the
 *   rollout list (or the list contains the all-channels entry).
 */
export default function isExtendedSeekEnabled(channelId) {
  if (!USE_LL_EXTENDED_SEEK) return false;
  return LL_EXTENDED_SEEK_CHANNELS.has(channelId)
    || LL_EXTENDED_SEEK_CHANNELS.has(valuesAllChannelsCatchup);
}
